import { ServerError } from '@apollo/client';
import { newRelicClient } from './newrelicClient';

const ERRORS_TO_IGNORE = ["Please confirm your credit card's security code to place your order."];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const reportError = (error: any) => {
  // eslint-disable-next-line no-console
  console.error(error);

  const networkErrorMessage = (error?.networkError as ServerError)?.result?.errors?.[0]?.detail;
  const message =
    networkErrorMessage ||
    (error?.displayMessage as ServerError) ||
    'An error occurred. Please retry later.';

  if (!ERRORS_TO_IGNORE.includes(message)) {
    newRelicClient?.noticeError(error, { name: error?.displayMessage, message: message });
  }
};
